import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { generateAccessFromPermissions } from "../../constants/moduleRouteMap";
import StoreList from "./StoreList";
import AuthAPI from "../../api/authApi";
import { showError } from "../../utils/toastUtils";
import { useLoader } from "../../utils/LoaderUtils";
import StoreAdminAPI from "../../api/StoreAdminApi";
import pkg from "../../../package.json";
import { UserContext } from "../../utils/UserContext";
import { clearAccessToken } from "../../api/axiosInstance";
import { useNotification } from "../../context/NotificationContext";
import NotificationRow from "./NotificationRow";
import ORDER_CONSTANTS from "../../constants/orderConstants";
import AddNewCard from "./header/AddNewCard";

function Header() {
  const APP_VERSION = pkg.version || "2.0";

  const { orders, unread, setUnread } = useNotification();
  const { showLoader, hideLoader } = useLoader();
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useContext(UserContext);

  const {
    name = "Guest User",
    roles = "User",
    image,
    storeId,
    logo,
    storeName,
    websiteUrl,
  } = user || {};

  const savedStoreName = localStorage.getItem("selectedStoreName");
  const [selectStore, setSelectStore] = useState(
    savedStoreName || storeName || "Select Store",
  );
  const [selectStoreVal, setSelectStoreVal] = useState(false);
  const [isSidebarActive, setIsSidebarActive] = useState(false);

  const navigate = useNavigate();
  const currentPath = useLocation().pathname;

  const access = generateAccessFromPermissions(
    user,
    selectStore !== "Select Store",
  );
  const allowedItems = access.sidebar;

  const handleToggle = () => {
    setIsSidebarActive((prev) => !prev);
  };

  const handleOpenStoreCanvas = () => {
    setSelectStoreVal(true);
  };

  const handleLogout = async () => {
    try {
      await AuthAPI.logOut();

      clearAccessToken();
      localStorage.removeItem("user");
      localStorage.removeItem("selectedStore");
      localStorage.removeItem("selectedStoreID");
      localStorage.removeItem("selectedStoreName");

      navigate("/");
    } catch (err) {}
  };

  const updateSelectedStore = async (name = "", id = null) => {
    showLoader();
    try {
      if (id === null) {
        localStorage.removeItem("selectedStore");
        localStorage.removeItem("selectedStoreID");
        localStorage.removeItem("selectedStoreName");
      } else {
        const res = await StoreAdminAPI.updateSelectedStore({ storeId: id });

        if (res.code === 200) {
          setSelectStore(name || "Select Store");

          if (id) {
            localStorage.setItem("selectedStore", res.data);
            localStorage.setItem("selectedStoreID", id);
            localStorage.setItem("selectedStoreName", name);
          }
        } else {
          showError(res.message);
        }
      }
    } catch (err) {
      hideLoader();
    } finally {
      navigate("/dashboard", { replace: true });
    }
  };

  return (
    <>
      <meta charSet="utf-8" />
      <title>AxeSell - Ecom Solution</title>
      <link
        type="image/x-icon"
        rel="shortcut icon"
        href={logo || `${process.env.PUBLIC_URL}/img/logo.png`}
      />
      <link rel="stylesheet" href="/css/bootstrap-datetimepicker.min.css" />
      <link rel="stylesheet" href="/css/animate.css" />
      <link rel="stylesheet" href="/plugins/select2/css/select2.min.css" />
      <link
        rel="stylesheet"
        href="/plugins/daterangepicker/daterangepicker.css"
      />
      <link rel="stylesheet" href="/plugins/tabler-icons/tabler-icons.css" />
      <link
        rel="stylesheet"
        href="/plugins/fontawesome/css/fontawesome.min.css"
      />
      <link rel="stylesheet" href="/plugins/fontawesome/css/all.min.css" />
      <link
        rel="stylesheet"
        href="/plugins/@simonwep/pickr/themes/nano.min.css"
      />
      <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
      <div className={`main-wrapper ${isOpen ? "slide-nav" : ""}`}>
        <div className="header">
          <div className="main-header">
            <div className="header-left">
              <Link to="dashboard" className="logo logo-normal">
                <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
              </Link>
              <Link to="dashboard" className="logo logo-white">
                <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
              </Link>
              <Link to="dashboard" className="logo-small">
                <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
              </Link>
            </div>
            <a
              id="mobile_btn"
              className="mobile_btn"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="bar-icon">
                <span />
                <span />
                <span />
              </span>
            </a>
            <ul className="nav user-menu">
              <li className="nav-item nav-searchinputs">
                {storeName && (
                  <a
                    href={websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b>{storeName.toUpperCase() ?? ""}</b>
                  </a>
                )}
              </li>

              {roles !== "SUPERADMIN" && (
                <>
                  {allowedItems.includes("pos") && (
                    <li className="nav-item dropdown link-nav">
                      <Link
                        to="/pos"
                        className="btn btn-secondary btn-md d-inline-flex align-items-center"
                      >
                        <i className="ti ti-device-laptop me-1"></i>POS
                      </Link>
                    </li>
                  )}

                  <li className="nav-item dropdown link-nav">
                    <a
                      href="javascript:void(0);"
                      className="btn btn-primary btn-md d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-circle-plus me-1"></i>Quick Links
                    </a>
                    <div className="dropdown-menu dropdown-xl dropdown-menu-center">
                      <AddNewCard />
                    </div>
                  </li>
                </>
              )}

              <li className="nav-item dropdown nav-item-box">
                <a
                  href="#"
                  className="dropdown-toggle nav-link position-relative"
                  data-bs-toggle="dropdown"
                  onClick={() => setUnread(false)}
                >
                  <i className="ti ti-bell"></i>
                  {unread && (
                    <span className="badge bg-danger position-absolute top-0 start-100 translate-middle p-1 rounded-circle">
                      {orders?.length}
                    </span>
                  )}
                </a>

                <div className="dropdown-menu notifications">
                  <div className="topnav-dropdown-header">
                    <h5>Notifications</h5>
                  </div>

                  <div className="noti-content">
                    <ul className="notification-list">
                      {orders.length === 0 ? (
                        <li className="text-center p-2">No new orders</li>
                      ) : (
                        orders.map((order) => (
                          <NotificationRow order={order} key={order.orderId} />
                        ))
                      )}
                    </ul>
                  </div>

                  <div className="topnav-dropdown-footer">
                    <Link to="/orders/all">View all</Link>
                  </div>
                </div>
              </li>

              {allowedItems.includes("stores") && (
                <li className="nav-item nav-item-box">
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                    onClick={handleOpenStoreCanvas}
                  >
                    {selectStore}
                  </button>
                </li>
              )}
              <li className="nav-item nav-item-box">
                <a id="btnFullscreen" onClick={(e) => e.preventDefault()}>
                  <i className="ti ti-maximize" />
                </a>
              </li>

              <li className="nav-item dropdown has-arrow main-drop profile-nav">
                <a className="nav-link userset" data-bs-toggle="dropdown">
                  <span className="user-info p-0">
                    <span className="user-letter">
                      <img
                        src={
                          image ||
                          `${process.env.PUBLIC_URL}/img/users/user-49.png`
                        }
                        className="img-fluid"
                      />
                    </span>
                  </span>
                </a>
                <div className="dropdown-menu menu-drop-user">
                  <div className="profileset d-flex align-items-center">
                    <span className="user-img me-2">
                      <img
                        src={
                          image ||
                          `${process.env.PUBLIC_URL}/img/users/user-49.png`
                        }
                      />
                    </span>
                    <div>
                      <h6 className="fw-medium">
                        <Link to="/user/my-profile">{name}</Link>
                      </h6>
                      <p>{roles}</p>
                    </div>
                  </div>
                  <Link className="dropdown-item" to="user/my-profile">
                    <i className="ti ti-user-circle me-2" />
                    MyProfile
                  </Link>
                  <Link className="dropdown-item" to="user/change-password">
                    <i className="ti ti-key me-2" />
                    Change Password
                  </Link>
                  {allowedItems.includes("company-settings") && (
                    <Link className="dropdown-item" to="store/settings">
                      <i className="ti ti-settings-2 me-2" />
                      Company Settings
                    </Link>
                  )}
                  <a className="dropdown-item logout" onClick={handleLogout}>
                    <i className="ti ti-logout me-2" />
                    Logout
                  </a>
                  <a className="dropdown-item text-dark text-center active mt-1">
                    <span className="align-middle fs-12 text-muted">
                      Version {APP_VERSION}
                    </span>
                  </a>
                  <a className="dropdown-item text-dark text-center active">
                    <span className="align-middle fs-12 text-muted">
                      Powered By AxeSell
                    </span>
                  </a>
                </div>
              </li>
            </ul>
            <div className="dropdown mobile-user-menu">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v" />
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                {allowedItems.includes("stores") && (
                  <a
                    className="dropdown-item text-primary"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                    onClick={handleOpenStoreCanvas}
                  >
                    {selectStore}
                  </a>
                )}

                <Link className="dropdown-item" to="/user/my-profile">
                  My Profile
                </Link>
                <Link className="dropdown-item" to="/user/change-password">
                  Change Password
                </Link>
                <a className="dropdown-item" onClick={handleLogout}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="sidebar" id="sidebar">
          <div className="sidebar-logo">
            <Link to="dashboard" className="logo logo-normal">
              <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
            </Link>
            <Link to="dashboard" className="logo logo-white">
              <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
            </Link>
            <Link to="dashboard" className="logo-small">
              <img src={logo || `${process.env.PUBLIC_URL}/img/logo.png`} />
            </Link>
            <a id="toggle_btn" href="#" onClick={handleToggle}>
              <i
                className={`ti ${
                  isSidebarActive ? "ti-arrow-right" : "ti-arrow-left"
                }`}
              />
            </a>
          </div>

          <div className="modern-profile p-3 pb-0">
            <div className="text-center rounded bg-light p-2 mb-2 user-profile">
              <div className="d-flex align-items-center">
                <a className="avatar me-2">
                  <img
                    src={
                      image || `${process.env.PUBLIC_URL}/img/users/user-49.png`
                    }
                    className="img-fluid object-fit-cover"
                  />
                </a>
                <div className="text-start">
                  <h6>
                    <Link to="/user/my-profile" className="fs-12">
                      {name}
                    </Link>
                  </h6>
                  <p className="fs-10 mb-0">{roles}</p>
                  {storeName && (
                    <p className="fs-10 mb-0">{storeName.toUpperCase()}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="submenu-open">
                  <h6 className="submenu-hdr">Analytics & Reports</h6>
                  <ul>
                    <li>
                      <Link
                        to="/dashboard"
                        className={currentPath === "/dashboard" ? "active" : ""}
                      >
                        <i className="ti ti-layout-grid fs-14 me-2" />
                        <span>Analytics</span>
                      </Link>
                    </li>

                    {allowedItems.includes("wishlist") && (
                      <li>
                        <Link
                          to="wishlist"
                          className={
                            currentPath === "/wishlist" ? "active" : ""
                          }
                        >
                          <i className="ti ti-heart fs-14 me-2" />
                          <span>Wishlist</span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>

                {allowedItems.includes("stores") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Store Management</h6>
                    <ul>
                      <li>
                        <Link
                          to="stores/list"
                          className={
                            currentPath === "/stores/list" ? "active" : ""
                          }
                        >
                          <i className="ti ti-home fs-14 me-2" />
                          <span>Stores List</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="stores/add-new/general"
                          className={
                            currentPath === "/stores/add-new/general"
                              ? "active"
                              : ""
                          }
                        >
                          <i className="ti ti-plus fs-14 me-2" />
                          <span>Add New Store</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                {allowedItems.includes("storeadmin") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">User Management</h6>
                    <ul>
                      <li>
                        <Link
                          to="stores/admin/list"
                          className={
                            currentPath === "/stores/admin/list" ? "active" : ""
                          }
                        >
                          <i className="ti ti-user-edit fs-14 me-2" />
                          <span>Store's Admin</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                {allowedItems.includes("orders") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Order Management</h6>
                    <ul>
                      <li>
                        <Link
                          to="orders/all"
                          className={
                            currentPath === "/orders/all" ? "active" : ""
                          }
                        >
                          <i className="ti ti-list-details fs-14 me-2" />
                          <span>All Orders</span>
                        </Link>
                      </li>

                      {Object.entries(ORDER_CONSTANTS).map(([key, label]) => (
                        <li key={key}>
                          <Link
                            to={`orders/${key}`}
                            className={
                              currentPath === `/orders/${key}` ? "active" : ""
                            }
                          >
                            <i className="ti ti-list-details fs-14 me-2" />
                            <span>{label} Orders</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                )}

                {allowedItems.includes("shipping") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Shipping Management</h6>
                    <ul>
                      <li>
                        <Link
                          to="shipments/all"
                          className={
                            currentPath === "/shipments/all" ? "active" : ""
                          }
                        >
                          <i className="ti ti-list-details fs-14 me-2" />
                          <span>All Shipments</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="shipments/delivered"
                          className={
                            currentPath === "/shipments/delivered"
                              ? "active"
                              : ""
                          }
                        >
                          <i className="ti ti-check fs-14 me-2" />
                          <span>Delivered Shipments</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="shipments/cancelled"
                          className={
                            currentPath === "/shipments/cancelled"
                              ? "active"
                              : ""
                          }
                        >
                          <i className="ti ti-x fs-14 me-2" />
                          <span>Cancelled Shipments</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                {(allowedItems.includes("customer") ||
                  allowedItems.includes("queries")) && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Customer Management</h6>
                    <ul>
                      {allowedItems.includes("customer") && (
                        <li>
                          <Link
                            to="customer/all"
                            className={
                              currentPath === "/customer/all" ? "active" : ""
                            }
                          >
                            <i className="ti ti-users fs-14 me-2" />
                            <span>All Customers</span>
                          </Link>
                        </li>
                      )}
                      {allowedItems.includes("queries") && (
                        <li>
                          <Link
                            to="queries"
                            className={
                              currentPath === "/queries" ? "active" : ""
                            }
                          >
                            <i className="ti ti-list-details fs-14 me-2" />
                            <span>Queries</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

                {(allowedItems.includes("my-store") ||
                  allowedItems.includes("sitemap") ||
                  allowedItems.includes("assets")) && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Store Management</h6>
                    <ul>
                      {allowedItems.includes("my-store") && (
                        <>
                          <li>
                            <Link
                              to={`stores/edit/${storeId || localStorage.getItem("selectedStoreID")}/general`}
                              className={
                                currentPath.includes(`stores/edit`)
                                  ? "active"
                                  : ""
                              }
                              state={{ name: storeName }}
                            >
                              <i className="ti ti-home fs-14 me-2" />
                              <span>My Store</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`stores/edit/${storeId || localStorage.getItem("selectedStoreID")}/warehouse-settings`}
                              className={
                                currentPath.endsWith(`warehouse-settings`)
                                  ? "active"
                                  : ""
                              }
                              state={{ name: storeName }}
                            >
                              <i className="ti ti-location fs-14 me-2" />
                              <span>Pickup Address</span>
                            </Link>
                          </li>
                        </>
                      )}

                      {allowedItems.includes("sitemap") && (
                        <li>
                          <Link
                            to={`sitemap`}
                            className={
                              currentPath === `/sitemap` ? "active" : ""
                            }
                          >
                            <i className="ti ti-world fs-14 me-2" />
                            <span>SiteMap</span>
                          </Link>
                        </li>
                      )}

                      {allowedItems.includes("assets") && (
                        <li>
                          <Link
                            to="gallery"
                            className={
                              currentPath === "/gallery" ? "active" : ""
                            }
                            state={{ name: storeName }}
                          >
                            <i className="ti ti-camera fs-14 me-2" />
                            <span>Gallery</span>
                          </Link>
                        </li>
                      )}

                      {/* {allowedItems.includes("staff") && (
                        <li>
                          <Link
                            to="users"
                            className={currentPath === "/users" ? "active" : ""}
                          >
                            <i className="ti ti-users fs-14 me-2" />
                            <span>Staff Management</span>
                          </Link>
                        </li>
                      )} */}
                    </ul>
                  </li>
                )}

                {(allowedItems.includes("products") ||
                  allowedItems.includes("category") ||
                  allowedItems.includes("inventory") ||
                  allowedItems.includes("brand")) && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Inventory Management</h6>
                    <ul>
                      {allowedItems.includes("products") && (
                        <li>
                          <Link
                            to="product"
                            className={
                              currentPath.startsWith("/product") ? "active" : ""
                            }
                          >
                            <i className="ti ti-box fs-14 me-2" />
                            <span>Products</span>
                          </Link>
                        </li>
                      )}
                      {allowedItems.includes("category") && (
                        <li>
                          <Link
                            to="category"
                            className={
                              currentPath.startsWith("/category")
                                ? "active"
                                : ""
                            }
                          >
                            <i className="ti ti-list-details fs-14 me-2" />
                            <span>Category</span>
                          </Link>
                        </li>
                      )}

                      {allowedItems.includes("brand") && (
                        <li>
                          <Link
                            to="brand"
                            className={
                              currentPath.startsWith("/brand") ? "active" : ""
                            }
                          >
                            <i className="ti ti-triangles fs-14 me-2" />
                            <span>Brands</span>
                          </Link>
                        </li>
                      )}

                      {allowedItems.includes("inventory") && (
                        <>
                          <li>
                            <Link
                              to="suppliers"
                              className={
                                currentPath.startsWith("/suppliers")
                                  ? "active"
                                  : ""
                              }
                            >
                              <i className="ti ti-user-plus fs-14 me-2" />
                              <span>Suppliers</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="inventory-list"
                              className={
                                currentPath.startsWith("/inventory-list")
                                  ? "active"
                                  : ""
                              }
                            >
                              <i className="ti ti-basket-down fs-14 me-2" />
                              <span>Inventory List</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="purchase-invoices"
                              className={
                                currentPath.startsWith("/purchase-invoices")
                                  ? "active"
                                  : ""
                              }
                            >
                              <i className="ti ti-file-invoice fs-14 me-2" />
                              <span>Purchase Invoices</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="stock-history"
                              className={
                                currentPath.startsWith("/stock-history")
                                  ? "active"
                                  : ""
                              }
                            >
                              <i className="ti ti-history fs-14 me-2" />
                              <span>Stock History</span>
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </li>
                )}

                {allowedItems.includes("customization") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Customize Form Management</h6>
                    <ul>
                      <li>
                        <Link
                          to="form"
                          className={
                            currentPath.startsWith("/form") ? "active" : ""
                          }
                        >
                          <i className="ti ti-list fs-14 me-2" />
                          <span>Form Management</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="submissions"
                          className={
                            currentPath.startsWith("/submissions")
                              ? "active"
                              : ""
                          }
                        >
                          <i className="ti ti-checklist fs-14 me-2" />
                          <span>Submissions</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                {allowedItems.includes("coupon") && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Promo Management</h6>
                    <ul>
                      {allowedItems.includes("coupon") && (
                        <li>
                          <Link
                            to="coupon"
                            className={
                              currentPath.startsWith("/coupon") ? "active" : ""
                            }
                          >
                            <i className="ti ti-ticket fs-14 me-2" />
                            <span>Coupon Management</span>
                          </Link>
                        </li>
                      )}
                      {allowedItems.includes("deal-of-the-day") && (
                        <li>
                          <Link
                            to="deal-of-the-day"
                            className={
                              currentPath.startsWith("/deal-of-the-day")
                                ? "active"
                                : ""
                            }
                          >
                            <i className="ti ti-ticket fs-14 me-2" />
                            <span>Deal of the Day Management</span>
                          </Link>
                        </li>
                      )}
                      {/* {allowedItems.includes("discount") && (
                        <li>
                          <Link
                            to="discount"
                            className={
                              currentPath === "/discount" ? "active" : ""
                            }
                          >
                            <i className="ti ti-file-percent fs-14 me-2" />
                            <span>Discount Management</span>
                          </Link>
                        </li>
                      )} */}
                    </ul>
                  </li>
                )}

                {(allowedItems.includes("blog") ||
                  allowedItems.includes("banners") ||
                  allowedItems.includes("testimonials") ||
                  allowedItems.includes("cms")) && (
                  <li className="submenu-open">
                    <h6 className="submenu-hdr">Website Management</h6>
                    <ul>
                      {allowedItems.includes("blog") && (
                        <li>
                          <Link
                            to="blog"
                            className={
                              currentPath.startsWith("/blog") ? "active" : ""
                            }
                          >
                            <i className="ti ti-list fs-14 me-2"></i>
                            <span>Blog Management</span>
                          </Link>
                        </li>
                      )}
                      {allowedItems.includes("banners") && (
                        <li>
                          <Link
                            to="banners"
                            className={
                              currentPath.startsWith("/banners") ? "active" : ""
                            }
                          >
                            <i className="ti ti-photo fs-14 me-2"></i>
                            <span>Banner Management</span>
                          </Link>
                        </li>
                      )}
                      {allowedItems.includes("testimonials") && (
                        <li>
                          <Link
                            to="testimonials"
                            className={
                              currentPath.startsWith("/testimonials")
                                ? "active"
                                : ""
                            }
                          >
                            <i className="ti ti-list fs-14 me-2"></i>
                            <span>Testimonial Management</span>
                          </Link>
                        </li>
                      )}

                      {allowedItems.includes("cms") && (
                        <>
                          <li>
                            <Link
                              to="cms/about-us"
                              className={
                                currentPath === "/cms/about-us" ? "active" : ""
                              }
                              state={{ preslug: "about-us" }}
                            >
                              <i className="fa fa-info-circle fs-14 me-2"></i>
                              <span>About Us</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="cms/terms-and-conditions"
                              className={
                                currentPath === "/cms/terms-and-conditions"
                                  ? "active"
                                  : ""
                              }
                              state={{ preslug: "terms-and-conditions" }}
                            >
                              <i className="fa fa-shield fs-14 me-2"></i>
                              <span>Terms & Condition</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="cms/privacy-policy"
                              className={
                                currentPath === "/cms/privacy-policy"
                                  ? "active"
                                  : ""
                              }
                              state={{ preslug: "privacy-policy" }}
                            >
                              <i className="fa fa-shield fs-14 me-2"></i>
                              <span>Privacy Policy</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="cms/return-and-refund-policy"
                              className={
                                currentPath === "/cms/return-and-refund-policy"
                                  ? "active"
                                  : ""
                              }
                              state={{ preslug: "return-and-refund-policy" }}
                            >
                              <i className="fa fa-shield fs-14 me-2"></i>
                              <span>Return/Refund Policy</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="cms/shipping-and-delivery-policy"
                              className={
                                currentPath ===
                                "/cms/shipping-and-delivery-policy"
                                  ? "active"
                                  : ""
                              }
                              state={{
                                preslug: "shipping-and-delivery-policy",
                              }}
                            >
                              <i className="fa fa-shield fs-14 me-2"></i>
                              <span>Shipping & Delivery Policy</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="cms/cancellation-policy"
                              className={
                                currentPath === "/cms/cancellation-policy"
                                  ? "active"
                                  : ""
                              }
                              state={{ preslug: "cancellation-policy" }}
                            >
                              <i className="fa fa-shield fs-14 me-2"></i>
                              <span>Cancellation Policy</span>
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        {selectStoreVal && (
          <StoreList
            onStoreSelect={(name, id) => {
              setSelectStore(name);
              updateSelectedStore(name, id);
            }}
          />
        )}
      </div>
    </>
  );
}

export default Header;
